module.exports = __webpack_public_path__ + "static/media/bzx.f45914a8.png";